module.exports = __webpack_public_path__ + "static/media/haute8D.5bc0eebc.jpg";